// Derive country (name + flag emoji) from a phone number like "+960 7XXXX"
// Uses libphonenumber-js + browser Intl.DisplayNames.
import { parsePhoneNumberFromString } from 'libphonenumber-js';

let regionNames = null;
try {
  if (typeof Intl !== 'undefined' && Intl.DisplayNames) {
    regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
  }
} catch {
  regionNames = null;
}

// ISO alpha-2 → flag emoji (regional indicator symbols: A=0x1F1E6)
export function flagFromCountryCode(cc) {
  if (!cc || cc.length !== 2) return '';
  const up = cc.toUpperCase();
  try {
    return String.fromCodePoint(
      0x1f1e6 + (up.charCodeAt(0) - 65),
      0x1f1e6 + (up.charCodeAt(1) - 65),
    );
  } catch {
    return '';
  }
}

export function countryFromPhone(phone) {
  if (!phone || typeof phone !== 'string') return { code: null, name: '—', flag: '' };
  try {
    // Ensure + prefix so parser treats it as international
    const raw = phone.trim();
    const p = parsePhoneNumberFromString(raw.startsWith('+') ? raw : `+${raw.replace(/^\+*/, '')}`);
    if (p && p.country) {
      const code = p.country;
      const name = regionNames ? regionNames.of(code) : code;
      return { code, name: name || code, flag: flagFromCountryCode(code) };
    }
  } catch {
    // ignore
  }
  return { code: null, name: '—', flag: '' };
}
